<div class="lpo-dialog-container">
  <div class="lpo-header-actions no-print" *ngIf="!isLoading && !showInitialChoice && !showUploadSection">
    <button mat-icon-button (click)="onBackToChoice()" *ngIf="
        isVendor && !data.booking.quotationGenerated && !data.booking.QUOTATION
      ">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <button mat-icon-button (click)="close()" *ngIf="
        !isVendor || data.booking.quotationGenerated || data.booking.QUOTATION
      ">
      <mat-icon>close</mat-icon>
    </button>
    <div class="spacer"></div>

    <!-- Customer Actions - Only show if Quotation not yet approved and NOT sample -->
    <ng-container *ngIf="
        !isVendor &&
        data.booking.quotationGenerated &&
        !data.booking.quotationApproved &&
        !isSample
      ">
      <button mat-flat-button color="primary" (click)="approveQuotation()" [disabled]="isSaving"
        style="margin-right: 10px; background-color: #28a745; color: white">
        <mat-icon>check</mat-icon> Approve Quotation
      </button>
      <button mat-flat-button color="warn" (click)="rejectQuotation()" [disabled]="isSaving" style="margin-right: 10px">
        <mat-icon>close</mat-icon> Reject Quotation
      </button>
    </ng-container>

    <!-- Vendor Actions: Save & Send (Generate) -->
    <button *ngIf="
        !data.booking.quotationGenerated &&
        !data.booking.quotationApproved &&
        isVendor &&
        !isSample
      " mat-flat-button color="primary" (click)="confirmSaveQuotation()" [disabled]="
        isSaving ||
        !(vendorDetails?.signatureUrl || vendorDetails?.signatureBase64) ||
        !consentGiven
      " style="margin-right: 10px">
      <mat-icon *ngIf="!isSaving">send</mat-icon>
      <mat-spinner *ngIf="isSaving" diameter="20"
        style="display: inline-block; margin-right: 5px; vertical-align: middle"></mat-spinner>
      Save
    </button>

    <button mat-raised-button color="primary" (click)="downloadPdf()">
      <mat-icon>picture_as_pdf</mat-icon> Download PDF
    </button>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" style="
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      min-height: 400px;
      gap: 24px;
    ">
    <div class="loader-container">
      <mat-spinner diameter="40" strokeWidth="4"></mat-spinner>
    </div>
    <div style="text-align: center">
      <h3 style="margin: 0; color: #334155; font-size: 18px; font-weight: 700">
        Preparing Quotation
      </h3>
      <p style="margin: 8px 0 0 0; color: #64748b; font-size: 14px">
        Synchronizing latest booking details...
      </p>
    </div>
  </div>

  <!-- Initial Choice Screen -->
  <div class="initial-choice-container" *ngIf="!isLoading && showInitialChoice">
    <button mat-icon-button (click)="close()" style="position: absolute; top: 20px; left: 20px">
      <mat-icon>close</mat-icon>
    </button>

    <h2>Quotation</h2>
    <p>
      How would you like to provide the Quotation for this booking? You can
      upload your own document or generate one digitally.
    </p>

    <div class="choice-buttons">
      <div class="choice-card" (click)="openUploadQuotationDialog()">
        <div class="icon-wrapper">
          <mat-icon>upload_file</mat-icon>
        </div>
        <div class="text-wrapper">
          <span>Upload Quotation</span>
          <small>Upload an existing PDF or image document from your device.</small>
        </div>
      </div>

      <div class="choice-card" (click)="onGenerateClick()">
        <div class="icon-wrapper">
          <mat-icon>edit_note</mat-icon>
        </div>
        <div class="text-wrapper">
          <span>Generate Digital Quotation</span>
          <small>Create a professional digital quotation using our smart
            template.</small>
        </div>
      </div>
    </div>
  </div>

  <!-- Upload Section -->
  <div class="initial-choice-container" *ngIf="!isLoading && showUploadSection">
    <button mat-icon-button (click)="onBackToChoice()" style="position: absolute; top: 20px; left: 20px">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <h2>Upload Quotation</h2>
    <p>
      Please select a PDF or image file of your Quotation to attach it to this
      booking.
    </p>

    <div class="upload-area-container">
      <div class="upload-drop-zone" [class.has-file]="selectedFile" (click)="openFilePicker()">
        <div class="upload-icon-circle">
          <mat-icon>{{
            selectedFile ? "description" : "picture_as_pdf"
            }}</mat-icon>
        </div>

        <div class="file-info" *ngIf="selectedFile">
          <span class="file-name">{{ selectedFile.name }}</span>
          <span class="file-size">{{ (selectedFile.size / 1024).toFixed(1) }} KB</span>
        </div>

        <p class="upload-prompt" *ngIf="!selectedFile">
          Drag & drop your file here or <strong>browse</strong>
        </p>

        <input type="file" #fileInput (change)="onFileSelected($event)" accept=".pdf,image/*" hidden />
      </div>

      <div class="upload-actions">
        <button mat-flat-button color="primary" class="confirm-upload-btn" [disabled]="!selectedFile || isSaving"
          (click)="uploadQuotation()">
          <mat-icon *ngIf="!isSaving">cloud_upload</mat-icon>
          <mat-spinner diameter="20" *ngIf="isSaving" style="margin-right: 8px"></mat-spinner>
          {{ isSaving ? "Uploading..." : "Confirm & Upload" }}
        </button>
      </div>
    </div>
  </div>

  <ng-container *ngIf="!isLoading && !showInitialChoice && !showUploadSection">
    <!-- Pending Approval Notice for Vendor -->
    <div *ngIf="
        isVendor &&
        data.booking.quotationGenerated &&
        !data.booking.quotationApproved &&
        !data.booking.quotationRejected &&
        !isSample
      " style="
        background-color: #e3f2fd;
        border: 1px solid #2196f3;
        border-radius: 8px;
        padding: 15px;
        margin: 10px 20px;
        display: flex;
        align-items: center;
        gap: 10px;
      ">
      <mat-icon style="color: #2196f3">pending_actions</mat-icon>
      <div style="flex: 1">
        <strong style="color: #0d47a1">Pending Customer Approval</strong>
        <p style="margin: 5px 0 0 0; color: #666; font-size: 14px">
          Your Quotation has been sent to the customer and is awaiting their
          approval.
        </p>
      </div>
    </div>

    <!-- Rejection Notice for Vendor -->
    <div *ngIf="
        isVendor &&
        data.booking.quotationRejected &&
        !data.booking.quotationApproved
      " style="
        background-color: #fff3cd;
        border: 1px solid #ffc107;
        border-radius: 8px;
        padding: 15px;
        margin: 10px 20px;
        display: flex;
        align-items: center;
        gap: 10px;
      ">
      <mat-icon style="color: #ff9800">warning</mat-icon>
      <div style="flex: 1">
        <strong style="color: #ff6f00">Quotation Rejected</strong>
        <p style="margin: 5px 0 0 0; color: #666; font-size: 14px">
          The customer has rejected your quotation.
        </p>
        <p *ngIf="data.booking.rejectionReason" style="
            margin: 5px 0 0 0;
            color: #d32f2f;
            font-size: 14px;
            font-weight: 500;
          ">
          <strong>Reason:</strong> {{ data.booking.rejectionReason }}
        </p>
        <p style="margin: 5px 0 0 0; color: #666; font-size: 14px">
          Please review, make necessary modifications, and resubmit.
        </p>
      </div>
    </div>

    <!-- Approval Notice -->
    <div *ngIf="data.booking.quotationApproved" style="
        background-color: #d4edda;
        border: 1px solid #28a745;
        border-radius: 8px;
        padding: 15px;
        margin: 10px 20px;
        display: flex;
        align-items: center;
        gap: 10px;
      ">
      <mat-icon style="color: #28a745">check_circle</mat-icon>
      <div style="flex: 1">
        <strong style="color: #155724">Quotation Approved</strong>
        <p style="margin: 5px 0 0 0; color: #666; font-size: 14px">
          This quotation has been approved. You can view and download it below.
        </p>
      </div>
    </div>

    <div class="lpo-scroll-area">
      <!-- Case 1: Uploaded Quotation file (only when NOT a digitally generated one) -->
      <div *ngIf="data.booking.QUOTATION && !data.booking.quotationGenerated" class="uploaded-doc-container">
        <div class="uploaded-quotation-preview">
          <iframe *ngIf="!isImage(data.booking.QUOTATION)" [src]="safeResourceUrl(data.booking.QUOTATION)"></iframe>
          <img *ngIf="isImage(data.booking.QUOTATION)" [src]="data.booking.QUOTATION" />
        </div>
      </div>


      <!-- Case 2: Digital Generated Quotation -->
      <div *ngIf="!data.booking.QUOTATION || data.booking.quotationGenerated" id="quotation-content" class="lpo-paper"
        [class.has-letterhead]="!!vendorDetails?.letterheadImageUrl">
        <!--
          ── LETTERHEAD BACKGROUND ──────────────────────────────────────────
          Rendered as position:absolute so all quotation text floats above it
          (z-index:0 here, z-index:2 on .quotation-content).
          For @media print: switched to position:fixed so the browser repeats
          it on every printed page automatically.
        -->
        <img *ngIf="vendorDetails?.letterheadImageUrl" [src]="vendorDetails.letterheadImageUrl" class="letterhead-bg"
          aria-hidden="true" alt="" />

        <!-- ── ALL QUOTATION CONTENT — floats above the letterhead bg ── -->
        <div class="quotation-content">

          <!-- Header (handles letterhead branding like V2) -->
          <app-quotation-header [branding]="vendorDetails?.quotationBranding"
            [vendorDetails]="vendorDetails"></app-quotation-header>

          <div class="quotation-body">

          <!-- Centered Quotation Heading -->
          <div class="receipt-center-title">
            <h2>QUOTATION</h2>
          </div>

          <!-- Body: Customer and Quotation Info -->
          <div class="receipt-body">
            <div class="section-box">
              <h3>BILL TO</h3>
              <p>
                <strong>{{
                  customerDetails?.companyName || "Customer Name"
                  }}</strong>
              </p>
              <p>{{ customerDetails?.companyDetails || "Customer Address" }}</p>
              <p>
                Phone:
                {{ customerDetails?.phoneNumber || data.booking.customer?.phone }}
                <br />
                Email: {{ customerDetails?.email }}
              </p>
            </div>

            <div class="section-box align-right">
              <h3>Quotation Details</h3>
              <p class="ref-no">
                Ref No: QT-{{ data.booking.id.slice(-6).toUpperCase() }}
              </p>
              <p class="date">Date: {{ quotationDate | date: "dd MMM yyyy" }}</p>
              <p *ngIf="vendorDetails?.trn">TRN: {{ vendorDetails.trn }}</p>
            </div>
          </div>

          <!-- Booking Details Section -->
          <div class="receipt-body no-margin">
            <div class="section-box full-width">
              <h3>EQUIPMENT HIRE DETAILS</h3>
              <table class="financial-table">
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>Description</th>
                    <th class="text-center">Rate</th>
                    <th class="text-center">Duration</th>
                    <th class="text-center">Unit</th>
                    <th class="text-right">Amount (AED)</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Equipment rows -->
                  <tr *ngFor="let eq of equipments; let eqIdx = index">
                    <td>{{ eqIdx + 1 }}</td>
                    <td>
                      <strong>{{ eq.name || eq.customEquipmentName || data.booking.equipment?.name || 'Equipment' }}</strong>
                      <br *ngIf="data.booking?.isVendorOwnBooking && (eq.brand || eq.model)" />
                      <span class="sub-text" *ngIf="data.booking?.isVendorOwnBooking && (eq.brand || eq.model)">{{ eq.brand }} {{ eq.model }}</span>
                    </td>
                    <td class="text-center">{{ (eq.price || totalAmount) | number: '1.0-2' }}</td>
                    <td class="text-center">{{ getEquipmentDurationValue(eq) }}</td>
                    <td class="text-center">{{ getEquipmentUnit(eq) }}</td>
                    <td class="text-right">AED {{ getEquipmentAmount(eq) | number: '1.0-2' }}</td>
                  </tr>

                  <!-- Additional Charges -->
                  <ng-container *ngIf="additionalChargesList.length > 0">
                    <tr class="summary-divider-row"><td colspan="6"></td></tr>
                    <tr *ngFor="let charge of additionalChargesList; let idx = index" class="additional-charge-unified">
                      <td>{{ equipments.length + idx + 1 }}</td>
                      <td><strong>{{ charge.description || 'Additional Charge' }}</strong></td>
                      <td class="text-center">{{ (charge.rate || 0) | number: '1.0-2' }}</td>
                      <td class="text-center">{{ charge.duration || 1 }}</td>
                      <td class="text-center">{{ charge.unit || 'Unit' }}</td>
                      <td class="text-right">AED {{ (charge.amount || 0) | number: '1.2-2' }}</td>
                    </tr>
                  </ng-container>

                  <!-- Subtotal -->
                  <tr class="merged-financial-row subtotal-row">
                    <td colspan="5" class="label-cell" style="font-size: 14px; font-weight: 600;">Subtotal</td>
                    <td class="text-right val-cell" style="font-size: 14px; font-weight: 600;">
                      <strong>AED {{ (getSubTotal() + getTotalAdditionalCharges()) | number: '1.2-2' }}</strong>
                    </td>
                  </tr>

                  <!-- VAT -->
                  <tr class="merged-financial-row">
                    <td colspan="5" class="label-cell">VAT ({{ getVatRate() }}%)</td>
                    <td class="text-right val-cell">{{ getVatAmount() | number: '1.2-2' }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="total-row">
                    <td colspan="5" class="text-right"><strong>TOTAL (AED)</strong></td>
                    <td class="text-right"><strong>AED {{ getFinalTotalWithVat() | number: '1.2-2' }}</strong></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          <!-- Notes/Terms -->
          <div class="notes-section">
            <h3>Terms &amp; Conditions</h3>
            <div class="section-body-text">{{ termsAndConditions }}</div>
          </div>

          <!-- Signature & Digital Seal Section -->
          <div class="signature-section">
            <div class="sig-and-seal">

              <!-- Vendor Signature block -->
              <div class="sig-block">
                <!-- Signature image if present -->
                <ng-container *ngIf="vendorDetails?.signatureUrl || vendorDetails?.signatureBase64; else noSigV2">
                  <div class="signature-display">
                    <img [src]="vendorDetails.signatureBase64 || vendorDetails.signatureUrl" alt="Authorized Signature" />
                    <button *ngIf="isVendor && !data.booking.quotationGenerated" mat-icon-button color="warn"
                      class="no-print" (click)="vendorDetails.signatureUrl = undefined; vendorDetails.signatureBase64 = undefined"
                      style="position: absolute; top: -10px; right: -10px; background: white; border: 1px solid #cbd5e1; border-radius: 50%; width: 24px; height: 24px; line-height: 24px; min-width: auto; padding: 0;">
                      <mat-icon style="font-size: 14px; width: 14px; height: 14px; line-height: 14px;">close</mat-icon>
                    </button>
                  </div>
                </ng-container>

                <ng-template #noSigV2>
                  <!-- Vendor pre-send: tabs to upload/draw -->
                  <div class="sig-dashed-box no-print"
                    *ngIf="isVendor && !data.booking.quotationGenerated; else blankSigV2">
                    <!-- keep tab-group for draw/upload if needed -->
                    <mat-tab-group [(selectedIndex)]="selectedTabIndex" animationDuration="0ms"
                      style="margin: 0; height: 100%;">
                      <mat-tab label="Upload">
                        <div style="padding: 8px; text-align: center;">
                          <button mat-stroked-button color="primary" (click)="triggerSigInput()" style="font-size: 11px;">
                            <mat-icon style="font-size: 14px; height: 14px; width: 14px;">upload</mat-icon> Upload Signature
                          </button>
                          <input type="file" id="quotationSigInput" (change)="onSigSelected($event)" accept="image/*" hidden />
                        </div>
                      </mat-tab>
                      <mat-tab label="Draw">
                        <div style="padding: 4px;">
                          <canvas #sigCanvas width="160" height="50" (mousedown)="startDrawing($event)"
                            (mousemove)="draw($event)" (mouseup)="stopDrawing()" (mouseleave)="stopDrawing()"
                            style="border: 1px solid #ccc; background: #fff; cursor: crosshair; display: block;">
                          </canvas>
                          <div style="margin-top: 4px; display: flex; gap: 6px; justify-content: center;">
                            <button mat-button color="warn" (click)="clearCanvas()" style="font-size: 10px; height: 24px; line-height: 24px;">Clear</button>
                            <button mat-raised-button color="primary" (click)="saveCanvasSignature()" style="font-size: 10px; height: 24px; line-height: 24px;">Use</button>
                          </div>
                        </div>
                      </mat-tab>
                    </mat-tab-group>
                  </div>
                  <ng-template #blankSigV2>
                    <div class="sig-dashed-box"></div>
                  </ng-template>
                </ng-template>

                <div class="sig-line"></div>
                <p class="sig-caption">AUTHORIZED SIGNATURE</p>
              </div>

              <!-- Digital Seal — shown once quotation generated -->
              <div class="digital-seal" *ngIf="data.booking.quotationGenerated || digitalSignature">
                <div class="seal-header">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#10b981" width="14" height="14"
                    style="display: inline-block; vertical-align: middle; margin-right: 4px;">
                    <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
                  </svg>
                  <span class="seal-title">Digitally Signed</span>
                </div>
                <div class="seal-body">
                  <div class="seal-row">
                    <span class="seal-label">Signed By</span>
                    <span class="seal-value">{{ vendorDetails?.companyName || vendorDetails?.name || "Vendor" }}</span>
                  </div>
                  <div class="seal-row">
                    <span class="seal-label">Date &amp; Time</span>
                    <span class="seal-value">{{ digitalSignature?.signedAt | date: "dd MMM yyyy, HH:mm" }}</span>
                  </div>
                  <div class="seal-row">
                    <span class="seal-label">Reference</span>
                    <span class="seal-value">{{ data.booking.quotationNumber || data.booking.id.slice(-6).toUpperCase() }}</span>
                  </div>
                </div>
              </div>

            </div><!-- /sig-and-seal -->

            <!-- Consent checkbox — vendor only, before sending -->
            <div class="digital-consent-block pointer-cursor no-print"
              *ngIf="isVendor && !data.booking.quotationApproved && !isSample" (click)="toggleConsent()">
              <div class="consent-checkbox-row">
                <div class="consent-checkbox" [class.checked]="consentGiven">
                  <mat-icon *ngIf="consentGiven" class="check-icon-size">check</mat-icon>
                </div>
                <div class="consent-header-text">Electronically Approved</div>
              </div>
              <div class="consent-meta-info">
                <div class="meta-row">
                  <span class="meta-label">Vendor:</span>
                  <span class="meta-val">{{ vendorDetails?.companyName || vendorDetails?.name || 'Vendor' }}</span>
                </div>
                <div class="meta-row" *ngIf="consentGiven">
                  <span class="meta-label">Date:</span>
                  <span class="meta-val">{{ quotationDate | date: 'dd MMM yyyy' }}</span>
                </div>
              </div>
            </div>

            <!-- Printed consent declaration -->
            <div class="digital-consent-printed no-print" *ngIf="data.booking.quotationGenerated && consentRecord">
              <mat-icon class="consent-print-icon">how_to_reg</mat-icon>
              <div class="printed-consent-info">
                <strong>Vendor Declaration:</strong> {{ consentRecord.vendorName }} confirmed accuracy &amp;
                submission on {{ consentRecord.agreedAt | date: 'dd MMM yyyy, HH:mm' }}.
              </div>
            </div>

          </div><!-- /signature-section -->
          </div><!-- /quotation-body -->

          <app-quotation-footer [branding]="vendorDetails?.quotationBranding"
            [vendorDetails]="vendorDetails"></app-quotation-footer>

        </div>
        <!-- /quotation-content -->
      </div>
      <!-- /lpo-paper -->
    </div>
    <!-- /lpo-scroll-area -->
  </ng-container>
</div>